import { defineMessages } from 'react-intl';

export default defineMessages({
  errorLabel: {
    id: 'neptune.StatusIcon.iconLabel.error',
    defaultMessage: 'Error:',
    description:
      'Visually hidden label read by screen readers, describing the Error icon – normally a prefix to remaining visible content, e.g. validation result.',
  },
  successLabel: {
    id: 'neptune.StatusIcon.iconLabel.success',
    defaultMessage: 'Success:',
    description:
      'Visually hidden label read by screen readers, describing the Success icon – normally a prefix to remaining visible content, e.g. validation result.',
  },
  warningLabel: {
    id: 'neptune.StatusIcon.iconLabel.warning',
    defaultMessage: 'Warning:',
    description:
      'Visually hidden label read by screen readers, describing the Warning icon – normally a prefix to remaining visible content, e.g. validation result.',
  },
  pendingLabel: {
    id: 'neptune.StatusIcon.iconLabel.pending',
    defaultMessage: 'Pending:',
    description:
      'Visually hidden label read by screen readers, describing the Pending icon – normally a prefix to remaining visible content, e.g. validation result.',
  },
  informationLabel: {
    id: 'neptune.StatusIcon.iconLabel.information',
    defaultMessage: 'Information:',
    description:
      'Visually hidden label read by screen readers, describing the Information icon – normally a prefix to remaining visible content, e.g. validation result.',
  },
});
